import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetSociogramTeacherAccess = (eventId) => {
  const query = useApiQuery(
    ['sociogramTeacherAccess', eventId],
    'schools',
      `/current-enrollment/sociograms/${eventId}/access`,
      { enabled: !!eventId },
      { authenticated: true, version: 5 }
  )

  return {
    isLoadingTeacherAccess: query.isLoading || query.isFetching,
    errorTeacherAccess: query.error ?? null,
    dataTeacherAccess: query.data ?? null,
    getTeacherAccess: query.refetch
  }
}
